import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import SessionFun from './functions/sessionFun';
import * as atlas from 'azure-maps-control';
import { getUserInfo } from './functions/userInfo';
import { environment } from './functions/environment';

var map, dataSource, layersList = [], polyPoint = [], polyCord = [];
var CirclePoint = new atlas.Shape(new atlas.data.Point([-73.985708, 40.75773]), null, {
    subType: "Circle",
    radius: 50
});

function AssetLocation() {
    const navigate = useNavigate();
    let params = useParams();
    let [geoList, setGeoList] = useState([]);
    let [sessOut, setSessOut] = useState(false);
    let [mapReady, setMapReady] = useState(false);
    let userObj = getUserInfo();

    useEffect(() => {
        if (mapReady) {
            if (params.geoName) {
                // let obj = JSON.parse(params.mapObj);
                let obj = {
                    geoName: params.geoName,
                    loc: (params.loc).split(',').map(function(item) {
                        return parseInt(item, 10);
                    }),
                    asset: params.asset
                }
                console.log(obj);
                getGeoList(obj);
            }
            else {
                navigate('/notification');
            }
        }
    }, [mapReady])

    useEffect(() => {
        InitMap();

    }, []);


    function InitMap(cord) {
        var compo = document.getElementById("mapDiv");
        map = new atlas.Map(compo, {
            center: [72.877426, 19.076090],//cord,//[72.877426, 19.076090],
            zoom: 16,
            language: 'en-US',
            // renderWorldCopies: false,
            // view: "Auto",
            authOptions: {
                authType: 'subscriptionKey',
                subscriptionKey: 'du-131aV_juHMnKzXuYjulfzzZdKfRCI2vIDu3V01VU'
            },
            showLogo: false,
            showFeedbackLink: false
        });

        map.events.add('ready', function () {
            dataSource = new atlas.source.DataSource();
            map.sources.add(dataSource);
            setMapReady(true);
        });
    }
    function getGeoList(object) {
        fetch(environment.baseUrl + "listGeofence", {
            method: "get",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((result) => {

            result.json().then((res) => {
                if (res.code == 200) {
                    setGeoList(res.data.result.geofenceList);
                    var results = res.data.result.geofenceList.filter(function (entry) { return entry.geofenceName === object.geoName; });
                    // console.log("data:", results);
                    drawOnmap(results[0], object.loc, object.asset)
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setGeoList([])
                }
            })

        })
    }
    function drawOnmap(geoObj, assetLoc, asset) {
        let cord = [];
        // cord = getCenterPoint(geoObj.coordinates); // focus on Geofence coordinates
        cord = assetLoc;// foccus on Assets coordinates
        setCamera(cord);

        if (geoObj.type === "Polygon") {
            markPolygon(geoObj.coordinates);
        }
        else {
            addCircle(geoObj.coordinates, geoObj.radius);
        }
        addMarkers(assetLoc, asset);
    }
    function addMarkers(cord, name) {
        var marker = new atlas.HtmlMarker({
            color: 'red',
            text: '',
            position: cord,
            popup: new atlas.Popup({
                content: '<div style="padding:10px">' + name + '</div>',
                pixelOffset: [0, -30]
            })
        });

        map.markers.add(marker);
        //Add a click event to toggle the popup.
        map.events.add('click', marker, () => {
            marker.togglePopup();
        });
    }
    function markPolygon(cord) {
        var layer = new atlas.layer.PolygonLayer(dataSource, 'myPolygonLayer', {
            fillColor: 'rgba(0, 200, 200, 0.5)'
        });

        map.layers.add(layer);
        var polygon = new atlas.Shape(new atlas.data.Polygon(cord));

        dataSource.add(polygon);
    }
    function addCircle(cord, rad) {
        CirclePoint.setCoordinates(cord);
        CirclePoint.addProperty("radius", rad);
        dataSource.add(CirclePoint);

        var layer = new atlas.layer.PolygonLayer(dataSource, null, {
            fillColor: 'red',
            fillOpacity: 0.2
        });
        map.layers.add(layer);
    }
    function setCamera(cord) {
        map.setCamera({
            center: cord,
            zoom: 16,
            duration: 3000,
            type: 'fly'
        });
    }
    function getCenterPoint(array) {
        let x = 0, y = 0, z = 0;
        array.forEach(element => {
            let log = element[0] * Math.PI / 180;
            let lat = element[1] * Math.PI / 180;
            x += Math.cos(lat) * Math.cos(log);
            y += Math.cos(lat) * Math.sin(log);
            z += Math.sin(lat);
        });

        let total = array.length;
        x = x / total;
        y = y / total;
        z = z / total;

        let clog = Math.atan2(y, x);
        let csqr = Math.sqrt(x * x + y * y);
        let clat = Math.atan2(z, csqr);

        let rlog = clog * 180 / Math.PI;
        let rlat = clat * 180 / Math.PI;

        return [rlog, rlat]
    }
    return (
        <div className='main-container'>
            <SessionFun show={sessOut}></SessionFun>
            <h4 className='main-heading'>Asset Location</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;
                <i className='fa fa-angle-right'></i></Link>&nbsp;Asset Location
            </p>
            <div className="row">
                <button className="btn-primary add-btn" onClick={() => { navigate('/notification') }} ><i className='fa fa-chevron-left ml-2'></i> Back</button>
            </div>
            <div className="card-box-block mt-3" style={{ width: "100%" }}>
                <div id="mapDiv" className="row mb-3" style={{ height: '400px' }}></div>
            </div>
        </div>
    )
}

export default AssetLocation
